module.exports = __webpack_public_path__ + "static/media/Usersnew.eed7212b.svg";